export default {
  EN_US: 'en-US',
  ES_US: 'es-US'
};
